import lodash from "lodash";
import { MapboxGeoJSONFeature } from "mapbox-gl";
import { MapboxSources } from "../../../mapbox";
import { Dict } from "../useDict";

// Generate an array of IDs for all Mapbox sources created by one of our data layers.
// Most data layers produce a single source.
// Some (e.g. layers with simplified geometry) produce several.
export function allMapboxSourceIds(sources: Dict<MapboxSources>): string[] {
  return lodash
    .chain(Object.values(sources))
    .flatMap(Object.keys)
    .uniq()
    .sort() // for debugging only
    .value();
}

export function groupFeaturesBySource(
  features: MapboxGeoJSONFeature[]
): Record<string, MapboxGeoJSONFeature[]> {
  return lodash.groupBy(features, feature => feature.source);
}
